import { Box, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';

import { inlineParts, parseAnswer } from './formatAnswer';

const Inline = ({ text }) => inlineParts(text).map((part, index) => (
  part.bold ? <strong key={index}>{part.text}</strong> : <span key={index}>{part.text}</span>
));

/** Dibuja la respuesta del asistente (párrafos, listas, tablas y negritas) sin insertar HTML. */
export default function AnswerBlocks({ text }) {
  return (
    <Box>
      {parseAnswer(text).map((block, index) => {
        if (block.type === 'heading') {
          return <Typography key={index} variant="subtitle1" fontWeight={700} sx={{ mt: index ? 1.5 : 0 }}><Inline text={block.text} /></Typography>;
        }
        if (block.type === 'list') {
          const Tag = block.ordered ? 'ol' : 'ul';
          return (
            <Box key={index} component={Tag} sx={{ my: 0.5, pl: 3 }}>
              {block.items.map((item, i) => <li key={i}><Typography variant="body2" component="span"><Inline text={item} /></Typography></li>)}
            </Box>
          );
        }
        if (block.type === 'table') {
          return (
            <Box key={index} sx={{ overflowX: 'auto', my: 1 }}>
              <Table size="small">
                <TableHead>
                  <TableRow>{block.header.map((cell, i) => <TableCell key={i} sx={{ fontWeight: 700 }}><Inline text={cell} /></TableCell>)}</TableRow>
                </TableHead>
                <TableBody>
                  {block.rows.map((row, r) => (
                    <TableRow key={r}>{row.map((cell, c) => <TableCell key={c}><Inline text={cell} /></TableCell>)}</TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          );
        }
        return <Typography key={index} variant="body2" sx={{ my: 0.5 }}><Inline text={block.text} /></Typography>;
      })}
    </Box>
  );
}
